var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSlice } from '@reduxjs/toolkit';
import API from '../../axios';
import { prepareSummary } from './utils/preSaveHandData';
import { getFLine, getPlayerFLine, getPlayerPrLine, getPlayerRLine, getPlayerTLine, getPrLine, getRLine, getTLine, } from './utils/getTrainerLines';
import { getEffStacks } from './utils/getPlayersStacks';
import { setTrainerInfoHandId } from './trainer';
import { setSavedHandId } from './trainerSettings';
var initialStateTable = {
    initialTrainerState: [],
    isHistoryClicked: 'noUndo',
    actionsHistory: [],
    isHeroTakingAction: false,
    isHandReplayed: false,
    replayingActionsHistory: [],
    // for walking for history
    historyActiveIndex: -1,
};
var initialState = {
    tables: [initialStateTable, initialStateTable, initialStateTable, initialStateTable],
};
var trainerActionsHistory = createSlice({
    initialState: initialState,
    name: 'trainerActionsHistory',
    reducers: {
        removeActionsHistoryElement: function (state, action) {
            var index = action.payload.index;
            state.tables[index].isHeroTakingAction = false;
            state.tables[index].actionsHistory = state.tables[index].actionsHistory.filter(function (item) { return !item.flag; });
        },
        setActionsHistory: function (state, action) {
            var _a = action.payload, actionHistory = _a.actionHistory, type = _a.type, index = _a.index;
            state.tables[index].actionsHistory = type === 'game' ? __spreadArray(__spreadArray([], state.tables[index].actionsHistory, true), [actionHistory], false) : [];
        },
        setUndoHistoryEl: function (state, action) {
            var _a = action.payload, historyIndex = _a.historyIndex, index = _a.index;
            state.tables[index].actionsHistory = state.tables[index].actionsHistory.filter(function (_, i) { return i < historyIndex; });
        },
        setIsHistoryClicked: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            state.tables[index].isHistoryClicked = data;
        },
        setIsHandReplayed: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            state.tables[index].isHandReplayed = data;
        },
        setReplayingActionsHistory: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            state.tables[index].replayingActionsHistory = data;
        },
        setResetHistoryState: function (state, action) {
            var index = action.payload.index;
            state.tables[index].isHistoryClicked = 'noUndo';
            state.tables[index].actionsHistory = [];
        },
        setIsHeroTakingAction: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            state.tables[index].isHeroTakingAction = data;
        },
        setInitialTrainerState: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            var initState = data.initState;
            state.tables[index].initialTrainerState = initState;
        },
        setReplayActionsHistory: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            if (data.split('_').length === 1) {
                state.tables[index].actionsHistory = [];
            }
            else {
                state.tables[index].actionsHistory = state.tables[index].actionsHistory.filter(function (el) { return el.isPrevActions; });
            }
        },
        setHistoryActiveIndex: function (state, action) {
            var _a = action.payload, index = _a.index, data = _a.data;
            state.tables[index].historyActiveIndex = data;
        },
    },
});
export var setReplayActionsHistory = function (index) { return function (dispatch, getState) {
    var currentQuery = getState().trainer.tables[index].currentQuery;
    dispatch(actions.setReplayActionsHistory({ data: currentQuery, index: index }));
}; };
export var setReplayingActionsHistory = function (typeActionFromHistory, index) { return function (dispatch) {
    dispatch(actions.setReplayingActionsHistory({ data: typeActionFromHistory, index: index }));
}; };
export var setIsHandReplayed = function (val, index) { return function (dispatch) {
    dispatch(actions.setIsHandReplayed({ data: val, index: index }));
}; };
export var setHistoryActiveIndex = function (idx, index) { return function (dispatch) {
    dispatch(actions.setHistoryActiveIndex({ data: idx, index: index }));
}; };
export var setResetHistoryState = function (index) { return function (dispatch) {
    dispatch(actions.setResetHistoryState({ index: index }));
}; };
export var setInitialTrainerState = function (_a) {
    var initState = _a.initState, trainerInfo = _a.trainerInfo, index = _a.index;
    return function (dispatch) {
        dispatch(actions.setInitialTrainerState({ data: { initState: initState, trainerInfo: trainerInfo }, index: index }));
    };
};
export var setUndoHistoryEl = function (historyIndex, index) { return function (dispatch) {
    dispatch(actions.setUndoHistoryEl({ historyIndex: historyIndex, index: index }));
}; };
export var setIsHistoryClicked = function (value, index) { return function (dispatch) {
    dispatch(actions.setIsHistoryClicked({ data: value, index: index }));
}; };
export var setActionsHistory = function (actionHistory, type, index) { return function (dispatch) {
    dispatch(actions.setActionsHistory({ actionHistory: actionHistory, type: type, index: index }));
}; };
export var setSaveTrainerHand = function (index, handId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, players, sessionId, isRiver, handNote, endStatus, playersAction, endActionQuery, currentQuery, _b, spotId, allPlayers, heroActivePlayer, spotName, gameMode, savedHandId, configurationId, url, oneHandSession, actionsHistory, traces, pot, startStack, effStack, playerIndex, endStacks, superPlayers, board, sessionStats, payloadToSave, payloadToUpdate, payload, response, _c, status, id, e_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState().trainer.tables[index], players = _a.players, sessionId = _a.sessionId, isRiver = _a.isRiver, handNote = _a.handNote, endStatus = _a.endStatus, playersAction = _a.playersAction, endActionQuery = _a.endActionQuery, currentQuery = _a.currentQuery;
                _b = getState().trainerSettings, spotId = _b.spotId, allPlayers = _b.allPlayers, heroActivePlayer = _b.heroActivePlayer, spotName = _b.spotName, gameMode = _b.gameMode, savedHandId = _b.savedHandId, configurationId = _b.configurationId;
                url = !savedHandId ? "save_hand_from_trainer" : 'update_trainer_hand';
                oneHandSession = getState().trainerSession.oneHandSession;
                actionsHistory = getState().trainerActionsHistory.tables[index].actionsHistory;
                traces = actionsHistory.map(function (el) { return el.customTraceObj; });
                pot = getState().trainer.tables[index].pot;
                startStack = currentQuery ? currentQuery.split('_')[0] : '';
                effStack = parseFloat(startStack);
                if (startStack.includes('-') && players) {
                    playerIndex = Object.keys(players).indexOf(heroActivePlayer[index]);
                    effStack = parseFloat(startStack.split('-')[playerIndex]);
                }
                endStacks = getEffStacks({ players: players, startStack: Number(effStack), actionsHistory: actionsHistory });
                superPlayers = allPlayers.map(function (el) {
                    var _a, _b;
                    var prPlayerLine = getPlayerPrLine({ actionsHistory: actionsHistory, player: el });
                    var flopPlayerLine = getPlayerFLine({ actionsHistory: actionsHistory, player: el });
                    var turnPlayerLine = getPlayerTLine({ actionsHistory: actionsHistory, player: el });
                    var rPlayerLine = getPlayerRLine({ actionsHistory: actionsHistory, player: el });
                    return prepareSummary({
                        player: el,
                        heroActivePlayer: heroActivePlayer[index],
                        fLine: flopPlayerLine,
                        rLine: rPlayerLine,
                        tLine: turnPlayerLine,
                        prLine: prPlayerLine,
                        players: players,
                        endStack: endStacks[el],
                        startStack: Number(effStack),
                        // @ts-ignore
                        isFold: ((_a = playersAction[el]) === null || _a === void 0 ? void 0 : _a.action) === 'Fold' || ((_b = players[el]) === null || _b === void 0 ? void 0 : _b.isFold),
                    });
                });
                board = actionsHistory
                    .filter(function (el) { return el.type === 'flop' || el.type === 'turn' || el.type === 'river'; })
                    .map(function (el) { return el === null || el === void 0 ? void 0 : el.action; })
                    .join('')
                    .replace(/[\s.,%]/g, '');
                sessionStats = __assign({}, oneHandSession);
                // @ts-ignore
                sessionStats.correctAnswers = sessionStats.correctAnswers.length;
                payloadToSave = {
                    session_id: sessionId,
                    game_mode: gameMode,
                    hand: {
                        configuration_id: configurationId,
                        hand_status: endStatus,
                        ante: 0,
                        // isError: false,
                        game_status: isRiver && endStatus === 'Showdown' ? 'Showdown' : '',
                        bb: 1,
                        board: board || '',
                        cap: false,
                        // currency: 'CHIPS',
                        eff_stack: Number(effStack),
                        ev_loss: 0,
                        f_line: getFLine({ actionsHistory: actionsHistory }) === '' ? null : getFLine({ actionsHistory: actionsHistory }),
                        full_query: endActionQuery,
                        // pokerformat: 'gto base',
                        pokergame: spotName,
                        pot: pot,
                        pr_line: getPrLine({ actionsHistory: actionsHistory }) === '' ? null : getPrLine({ actionsHistory: actionsHistory }),
                        query: endActionQuery,
                        r_line: getRLine({ actionsHistory: actionsHistory }) === '' ? null : getRLine({ actionsHistory: actionsHistory }),
                        // room: 'gto base',
                        sb: 0.5,
                        spot_id: spotId,
                        status: 'calculated',
                        t_line: getTLine({ actionsHistory: actionsHistory }) === '' ? null : getTLine({ actionsHistory: actionsHistory }),
                        tags: null,
                        gtolog: { trace: traces, isError: 0 },
                        players: superPlayers,
                        source: 'trainer',
                        hand_notes: handNote,
                        // handSessionStats: sessionStats,
                    },
                };
                payloadToUpdate = {
                    hand: {
                        hand_status: endStatus,
                        board: board || '',
                        f_line: getFLine({ actionsHistory: actionsHistory }) === '' ? null : getFLine({ actionsHistory: actionsHistory }),
                        full_query: endActionQuery,
                        pr_line: getPrLine({ actionsHistory: actionsHistory }) === '' ? null : getPrLine({ actionsHistory: actionsHistory }),
                        r_line: getRLine({ actionsHistory: actionsHistory }) === '' ? null : getRLine({ actionsHistory: actionsHistory }),
                        t_line: getTLine({ actionsHistory: actionsHistory }) === '' ? null : getTLine({ actionsHistory: actionsHistory }),
                        gtolog: { trace: traces, isError: 0 },
                        query: endActionQuery,
                    },
                    hand_id: savedHandId,
                };
                payload = !savedHandId ? payloadToSave : payloadToUpdate;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, API.post(url, payload)];
            case 2:
                response = _d.sent();
                _c = response.data, status = _c.status, id = _c.id;
                dispatch(setTrainerInfoHandId(id || handId, index));
                if (status === 'success') {
                    !savedHandId && dispatch(setSavedHandId(id));
                    return [2 /*return*/, {
                            isSuccess: true,
                            status: status,
                        }];
                }
                else {
                    return [2 /*return*/, {
                            isSuccess: false,
                            status: status,
                        }];
                }
                return [3 /*break*/, 4];
            case 3:
                e_1 = _d.sent();
                // @ts-ignore
                console.log('error', e_1.error);
                return [2 /*return*/, {
                        isSuccess: false,
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var reducer = trainerActionsHistory.reducer;
var actions = trainerActionsHistory.actions;
